import {$vfm} from 'vue-final-modal';
import commonFn from '@/commons/commonFunction.js';
import {MSConstant} from '@/commons/wildcards/index.js';
import {showError} from '@/commons/globalMessage';
import {useRoute, useRouter} from 'vue-router';
/**
 * Xử lý hiển thị popup
 */
class PopupUtil {
  /**
   * Đối tượng cache lại các component popup
   */
  _components = {};

  /**
   * Danh sách các popup đang hiển thị
   * key: tên popup
   * value: instance
   */
  _visible = {};

  /**
   * Danh sách tên popup đang hiển thị (fix lỗi không khai báo _visibleName)
   */
  _visibleName = [];

  /**
   * Lưu thông tin ds các popup theo subsystemcode
   */
  _registerPopup = {};

  /**
   * Mở popup
   * @param {string} name : Tên định danh
   * @param {object} params : tham số
   * @param {bool} ignoreCheckPermission : bỏ qua check quyền theo vai trò hay không
   * KHI THÊM THAM SỐ LƯU Ý BỔ SUNG THÊM TRONG CẢ orderPopupStore.js (nvxuan 20.02.2024)
   */
  show(name, params, ignoreCheckPermission, attrs) {
  
    if (!name) throw 'name of popup is required';
    const ps = params || {};
    ps.name = name;
    const subSystem = MSConstant.SubSystemCode[name];
    let check = true;
    if (name !== 'ConfirmRedirectPopup' && name !== 'AgreementNotAllowPopup') {
      check = commonFn.checkPermissionWithSubSystemCode(MSConstant.Permission.View, subSystem);
    }
    if (!check) {
      let msg = 'Bạn không có quyền thực hiện chức năng này. Vui lòng kiểm tra lại quyền của bạn.';
      let title = 'Không được phân quyền';
      showError(msg, title);
      throw msg;
    }
    if (!this._visibleName.includes(name)) {
      this._visibleName.push(name);
    }

    const popup = $vfm.show({component: name}, ps);
    console.log(`Popup name: ${name}`);

    this._visible[name] = popup;

    return popup;
    }

  /**
   * Đóng tất cả popup đang mở
   */
  hideAll() {
    $vfm.hideAll();
  }

  /**
   * Ẩn popup
   * @param {*} name
   * @returns
   */
  hide(name) {
    if (!name) throw 'name is required';
    const popup = $vfm.hide(name);

    return popup;
  }

  /**
   * Toggle popup
   * @param {*} name
   * @param {*} toggle
   * @returns
   */
  toggle(name, toggle) {
    if (!name) throw 'name is required';
    const popup = $vfm.toggle(name, toggle);

    return popup;
  }

  /**
   * Lưu lại thông tin phục vụ check quyền hạn khi show popup
   */
  registerPopup(keys, subSystemCode) {
    subSystemCode = subSystemCode.toLowerCase();
    let data = [];
    keys.filter(e => {
      data.push(e.toLowerCase());
    });
    const oldData = this._registerPopup[subSystemCode] || [];
    this._registerPopup[subSystemCode] = [...oldData, ...data].distinctKey();
  }
}

export default new PopupUtil();
